export default class PrimaryNavigation {
    constructor() {
        this.elements = {
            html: document.querySelector('html'),
            body: document.body,
            navicon: document.querySelectorAll('.c-menu-button'),
            menu: document.querySelectorAll('.c-nav-primary'),
            menuItem: document.querySelectorAll('.c-nav-primary > .menu > .menu-item'),
            menuItemHasChildren: document.querySelectorAll('.c-nav-primary .menu-item-has-children > .menu-link'),
            subMenu: document.querySelectorAll('.c-nav-primary .menu-item-has-children > .sub-menu'),
            backButton: document.querySelectorAll('.c-nav-primary .menu-item-has-children .menu-link--back'),
            offcanvasImages: document.querySelectorAll('.c-offcanvas__background-image'),
            defaultSidebarImage: document.querySelector('.c-offcanvas__background-image-default'),

        };

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.elements.navicon.forEach(element => {
            element.addEventListener('click', () => {
                let navClosing = this.elements.body.classList.contains('navigation-is-active')

                this.resetState(navClosing);
            })
        });

        this.elements.menuItem.forEach(item => {
            ['mouseenter', 'focusin', 'focus'].forEach(event => {
                item.addEventListener(event, () => {
                    this.hoverImage(item);
                })
            })
        });

        this.elements.menuItemHasChildren.forEach(item => {
            item.addEventListener('click', (e) => {
                this.toggleSubMenu(item, e);
            })
        })
        this.elements.backButton.forEach(item => {
            item.addEventListener('click', (e) => {
                this.toggleSubMenu(item, e);
            })
        })
    }

    toggleSubMenu(item, event) {
        event.preventDefault();

        this.toggleBodyClass('sub-menu-is-active');

        const subMenu = item.nextElementSibling;

        if (subMenu) {
            subMenu.classList.toggle('is-active');
        }

        if(item.classList.contains('menu-link--back')) {
            this.elements.body.classList.remove('sub-menu-is-active');

            this.elements.subMenu.forEach(item => {
                item.classList.remove('is-active');
            });
        }
    }

    toggleBodyClass(cssClass) {
        this.elements.body.classList.toggle(cssClass);

        if (this.elements.body.classList.contains('navigation-is-active')) {
            this.elements.html.setAttribute('data-scroll-direction', 'up');
        }
    }

    hoverImage(item) {
        const menuItemId = item.id;
        const relatedSidebarImageEl = document.querySelector(`.c-offcanvas__background-image.${menuItemId}`);

        document.querySelectorAll('.c-offcanvas__background-image').forEach(el => {
            el.classList.remove('is-active');
        });

        if (relatedSidebarImageEl) {
            relatedSidebarImageEl.classList.add('is-active');
        } else {
            const defaultImage = this.elements.defaultSidebarImage;
            if (defaultImage) {
                defaultImage.classList.add('is-active');
            }
        }
    }

    resetState(navIsClosing) {
        if (navIsClosing) {
            this.elements.body.classList.add('navigation-is-closing');

            if(this._navCloseTimeout) {
                clearTimeout(this._navCloseTimeout);
            }

            this._navCloseTimeout = setTimeout(() => {
                this.elements.body.classList.remove('navigation-is-closing')
                this._navCloseTimeout = null
            }, 3000);
        }

        this.toggleBodyClass('navigation-is-active');
        this.elements.body.classList.remove('booking--is-active');
        this.elements.body.classList.remove('sub-menu-is-active');

        this.elements.menuItemHasChildren.forEach(item => {
            item.classList.remove('is-active');
        });
        this.elements.subMenu.forEach(item => {
            item.classList.remove('is-active');
        });
    }
}
